// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"_17CN5","mainMenu_content":"_1c9DX","list":"_3BwVk","opened":"_1v8H_","topMenu":"_3n9L0","menuLocales":"_2YK1F"};